module.exports = __webpack_public_path__ + "img/iphone-downlod-app@3x.f680901e.png";